<form class="vl-form" id="edit-actor-form">
    <vl-modal :id="editActorModal" :closable="true" mod-medium>
        <vl-title tag-name="h3">{{ title }}</vl-title>
        <vl-u-spacer mod-small/>
        <vl-form-grid mod-stacked>
            <vl-column>
                <aeg-address-form v-model:address="billingAddress" :read-only="false" @validated="addressValidated"/>
            </vl-column>
        </vl-form-grid>
        <template v-slot:modal-footer>
            <vl-action-group>
                <vl-button mod-large :mod-disabled="invalidForm || isSavingActorDetails"
                           @click.prevent="handleFormSubmit">Wijzigingen opslaan
                </vl-button>&nbsp;
                <vl-link @click.prevent="onCloseModal" icon="cross" mod-icon-before>
                    Annuleer
                </vl-link>
            </vl-action-group>
        </template>
    </vl-modal>
</form>